import { useRecoilValue } from 'recoil'

import CardWithTabs from '../../../components/CardWithTabs'
import LineChart from '../../../components/LineChart'
import useCheckInEventForm from '../../../hooks/useCheckInEventForm'
import { ServiceAtom } from '../../../recoil/atoms'
import { roundDecimal } from '../../../utils/display'
import useGetRewardCountIssued from '../hooks/useGetRewardCountIssued'
import useGetRewardCountRedeemed from '../hooks/useGetRewardCountRedeemed'
import useGetRewardRedemptionRate from '../hooks/useGetRewardRedemptionRate'
import useGetStampCountIssued from '../hooks/useGetStampCountIssued'

function StampRewardPerformance({ className }: { className?: string }) {
  const { form } = useCheckInEventForm()
  const service = useRecoilValue(ServiceAtom)

  // APIs
  const { stampCountIssued, stampCountIssuedLoading } = useGetStampCountIssued({
    serviceId: service.value,
    campaignId: form.campaignId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })
  const { rewardCountIssued, rewardCountIssuedLoading } = useGetRewardCountIssued({
    serviceId: service.value,
    campaignId: form.campaignId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })
  const { rewardCountRedeemed, rewardCountRedeemedLoading } = useGetRewardCountRedeemed({
    serviceId: service.value,
    campaignId: form.campaignId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })
  const { rewardRedemptionRate, rewardRedemptionRateLoading } = useGetRewardRedemptionRate({
    serviceId: service.value,
    campaignId: form.campaignId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })

  return (
    <CardWithTabs
      className={className}
      title='チェックインスタンプ分析'
      tabs={[
        {
          title: 'スタンプ押印数',
          value: 'stamp',
          latest: stampCountIssued?.currentPeriodValue ?? 0,
          qty: '回',
          isLoading: stampCountIssuedLoading,
          children: (
            <LineChart
              groupLabel='スタンプ押印数'
              labels={stampCountIssued?.stampAnalyticsDatas?.map((e) => e.date) ?? []}
              datas={stampCountIssued?.stampAnalyticsDatas?.map((e) => e.value) ?? []}
              xAxisLabel=''
              yAxisLabel='(回)'
            />
          ),
        },
        {
          title: 'リワード発行数',
          value: 'isuuedReward',
          latest: rewardCountIssued?.currentPeriodValue ?? 0,
          qty: '回',
          isLoading: rewardCountIssuedLoading,
          children: (
            <LineChart
              groupLabel='リワード発行数'
              labels={rewardCountIssued?.rewardCountIssuedDatas?.map((e) => e.date) ?? []}
              datas={rewardCountIssued?.rewardCountIssuedDatas?.map((e) => e.value) ?? []}
              xAxisLabel=''
              yAxisLabel='(回)'
            />
          ),
        },
        {
          title: 'リワード利用数',
          value: 'usedReward',
          latest: rewardCountRedeemed?.currentPeriodValue ?? 0,
          qty: '回',
          isLoading: rewardCountRedeemedLoading,
          children: (
            <LineChart
              groupLabel='リワード利用数'
              labels={rewardCountRedeemed?.rewardCountRedeemedDatas?.map((e) => e.date) ?? []}
              datas={rewardCountRedeemed?.rewardCountRedeemedDatas?.map((e) => e.value) ?? []}
              xAxisLabel=''
              yAxisLabel='(回)'
            />
          ),
        },
        {
          title: 'リワード利用率',
          value: 'usageRatio',
          latest: roundDecimal(rewardRedemptionRate?.currentPeriodValue ?? 0, 2),
          qty: '%',
          isLoading: rewardRedemptionRateLoading,
          children: (
            <LineChart
              groupLabel='リワード利用率'
              labels={rewardRedemptionRate?.rewardRedemptionRateDatas?.map((e) => e.date) ?? []}
              datas={rewardRedemptionRate?.rewardRedemptionRateDatas?.map((e) => roundDecimal(e.value, 2)) ?? []}
              xAxisLabel=''
              yAxisLabel='(%)'
            />
          ),
        },
      ]}
    />
  )
}

StampRewardPerformance.defaultProps = {
  className: '',
}

export default StampRewardPerformance
